import { render } from "./AppCreateCasePopUp.vue?vue&type=template&id=9135fcee&scoped=true&ts=true"
import script from "./AppCreateCasePopUp.vue?vue&type=script&lang=ts"
export * from "./AppCreateCasePopUp.vue?vue&type=script&lang=ts"

import "./AppCreateCasePopUp.vue?vue&type=style&index=0&id=9135fcee&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9135fcee"]])

export default __exports__